module.exports = __webpack_public_path__ + "img/diet-heart-healthy.9e13c710.png";